var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowerInside = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.42 10.647H2a.78.78 0 0 1-.6-.31.74.74 0 0 1-.11-.66 11.4 11.4 0 0 1 4.117-5.9 11.43 11.43 0 0 1 13.666 0 11.4 11.4 0 0 1 4.117 5.9.74.74 0 0 1-.402.897.8.8 0 0 1-.368.073M3 9.149h18.37a9.9 9.9 0 0 0-3.656-4.47A9.94 9.94 0 0 0 3 9.15z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.19 3.026a.76.76 0 0 1-.75-.749V.75a.749.749 0 0 1 1.28-.53c.141.14.22.331.22.53v1.528a.76.76 0 0 1-.75.75z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.87 13.323a.38.38 0 1 1-.02.76.38.38 0 0 1 .02-.76m-6.11 6.093a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76m6.12 0a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76m6.1 0a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76M8.81 16.37a.38.38 0 1 1 0 .759.38.38 0 0 1 0-.76m6.11.001a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76m-6.11 6.092a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76m-6.1 0a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76m12.21 0a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76m6.06 0a.38.38 0 1 1 0 .76.38.38 0 0 1 0-.76"
})));
export default SvgShowerInside;